import React, { createContext, useContext, useState, useEffect } from "react";
import { useUserSessionContext } from "./UserSessionContext";
import { tenantApi } from "../apis/tenant/api";
import { TenantConfig } from "../types/tenant";

interface TenantContextType {
  tenantConfig: TenantConfig | null;
}

const TenantContext = createContext<TenantContextType | null>(null);

const TenantProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLoggedIn } = useUserSessionContext();
  const [tenantConfig, setTenantConfig] = useState<TenantConfig | null>(null);

  useEffect(() => {
    const fetchTenantConfig = async () => {
      if (!isLoggedIn || tenantConfig) return;

      const config = await tenantApi.getTenantConfiguration();
      setTenantConfig(config);
    };

    fetchTenantConfig();
  }, [isLoggedIn, tenantConfig]);

  return (
    <TenantContext.Provider
      value={{
        tenantConfig,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = () => {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error("useTenant must be used within a TenantProvider");
  }

  return context;
};

export default TenantProvider;
